// Re-export the GQL contacts hook under the legacy name.
// Real implementation: hooks/graphql/contacts/useContacts.ts
import { useContacts } from './graphql/contacts/useContacts';

export const useContactsData = useContacts;
export default useContactsData;
